module.exports = __webpack_public_path__ + "static/media/11.5addedd4.JPG";